import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Button, {} from '@helsenorge/designsystem-react/components/Button';
import Icon, {} from '@helsenorge/designsystem-react/components/Icon';
import LazyIcon from '@helsenorge/designsystem-react/components/LazyIcon';
import { getAppUrl as getAppUrlFrameworkUtils } from '@helsenorge/framework-utils/url';
import { HNeventShowAppInvitation } from '@helsenorge/framework-utils/web-component/events';
const LoginButton = ({ size = 'normal', concept = 'normal', href = '#', htmlMarkup = 'button', fluid = false, icon, rightSideIcon, children, ...rest }) => {
    const [appUrl, setAppUrl] = React.useState(undefined);
    const buttonRef = React.useRef(null);
    React.useEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect -- Vi trenger denne da vi leser fra window.navigator som ikke er ledig ved SSR.
        setAppUrl(getAppUrlFrameworkUtils());
    }, []);
    const triggerOriginalBehaviour = (e) => {
        if (rest.onClick) {
            rest.onClick(e);
        }
        if (href) {
            window.location.href = href;
        }
    };
    const getAppUrl = (appUrl) => {
        const url = new URL(href ? href : '');
        window.location.href = `${appUrl}?tjeneste=${url.pathname}${url.search}`;
    };
    const mobileOnClick = (e) => {
        if (appUrl) {
            e?.preventDefault();
            HNeventShowAppInvitation(() => {
                getAppUrl(appUrl);
            }, () => {
                triggerOriginalBehaviour();
            }, () => {
                buttonRef.current?.focus();
            });
        }
    };
    return (_jsxs(Button, { size: size, concept: concept, fluid: fluid, href: appUrl ? undefined : href, onClick: appUrl ? mobileOnClick : rest.onClick, htmlMarkup: appUrl ? 'button' : htmlMarkup, ref: buttonRef, children: [!!icon && _jsx(LazyIcon, { iconName: icon }), children, !!rightSideIcon && _jsx(Icon, { svgIcon: rightSideIcon })] }));
};
export default LoginButton;
